var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInscricoes = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "6BAA214C-C104-453F-94E5-FF760F51CA4D")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-",
    transform: "translate(-22.000000, -206.000000)",
    fill: "#4B4B4A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Copy-3",
    transform: "translate(0.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Menu-/-Banners",
    transform: "translate(20.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,4 C17.1045695,4 18,4.8954305 18,6 L18,18 C18,19.1045695 17.1045695,20 16,20 L4,20 C2.8954305,20 2,19.1045695 2,18 L2,6 C2,4.8954305 2.8954305,4 4,4 L16,4 Z M8.31438393,8.37678744 C7.8015481,8.37678744 7.37887677,8.76282763 7.32111167,9.26016632 L7.31438393,9.37678744 L7.31438393,14.6232126 C7.31438393,14.8175036 7.37098297,15.0075869 7.47726391,15.1702318 C7.75779499,15.599537 8.31216631,15.7421922 8.76009711,15.5184947 L8.86140319,15.4603326 L12.8757843,12.83712 C12.9914948,12.7615085 13.0902736,12.6627298 13.1658851,12.5470193 C13.4464161,12.1177141 13.3544635,11.5527161 12.96973,11.2323059 L12.8757843,11.16288 L8.86140319,8.53966742 C8.69875827,8.43338648 8.50867498,8.37678744 8.31438393,8.37678744 Z M14.5,2 C14.7761424,2 15,2.22385763 15,2.5 C15,2.77614237 14.7761424,3 14.5,3 L5.5,3 C5.22385763,3 5,2.77614237 5,2.5 C5,2.22385763 5.22385763,2 5.5,2 L14.5,2 Z M12.5,0 C12.7761424,-5.07265313e-17 13,0.223857625 13,0.5 C13,0.776142375 12.7761424,1 12.5,1 L7.5,1 C7.22385763,1 7,0.776142375 7,0.5 C7,0.223857625 7.22385763,5.07265313e-17 7.5,0 L12.5,0 Z",
    id: "Combined-Shape"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInscricoes, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/inscricoes.7b552e21.svg";
export { ForwardRef as ReactComponent };